import React from 'react';
import { Flex, H3, P, classNames, Hr } from '@tpr/core';
import styles from './card.module.scss';
export var StyledCard = function (_a) {
    var _b;
    var _c = _a.complete, complete = _c === void 0 ? false : _c, children = _a.children;
    return (React.createElement("div", { className: classNames([
            styles.card,
            (_b = {}, _b[styles['card-completed']] = complete, _b),
        ]) }, children));
};
export var StyledCardToolbar = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: styles.cardToolbar }, children);
};
export var Toolbar = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, sectionTitle = _a.sectionTitle;
    return (React.createElement(Flex, { cfg: { flexDirection: 'column', mt: 4, mb: 3 } },
        React.createElement(Flex, { cfg: { flexDirection: 'column', pb: 2 }, className: styles.toolbarBottomBorder },
            sectionTitle && (React.createElement(P, { cfg: { color: 'neutral.6', fontSize: 3 }, className: styles.noMarginBottom }, sectionTitle)),
            React.createElement(H3, { cfg: { fontWeight: 3 } }, title)),
        subtitle && (React.createElement(Flex, { cfg: { py: 3 }, className: styles.toolbarBottomBorder },
            React.createElement(P, { cfg: { color: 'neutral.6' }, className: styles.noMarginBottom }, subtitle)))));
};
export var Footer = function (_a) {
    var children = _a.children;
    return (React.createElement(Flex, { cfg: {
            flex: '0 0 auto',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            width: 10,
            mt: 5,
        } },
        React.createElement(Hr, { cfg: { mb: 6 } }),
        React.createElement(Flex, null, children)));
};
export var StatusMessage = function (_a) {
    var complete = _a.complete, Icon = _a.icon, text = _a.text;
    return (React.createElement(Flex, { cfg: { alignItems: 'center' }, height: "22px" },
        React.createElement(Icon, { size: 18, fill: complete ? styles.confirmed : styles.unconfirmed, ariaLabel: text }),
        React.createElement(P, { cfg: {
                ml: 1,
                fontSize: 2,
                fontWeight: 3,
                color: complete ? 'confirmed' : 'unconfirmed',
            }, className: styles.noMarginBottom }, text)));
};
//# sourceMappingURL=card.js.map